export enum CheckoutStep {
  FORM = 'FORM',
  UPSELL = 'UPSELL',
  PURCHASE = 'PURCHASE',
  COMPLETED = 'COMPLETED',
}
